<template>
  <div class="first-access-page">
    <div class="first-access-card">
      <h2 class="title">Activación inicial</h2>
      <p class="subtitle">
        Defina su contraseña final y confirme el recordatorio del acuerdo de responsabilidad.
      </p>

      <div v-if="message" class="alert" :class="isSuccess ? 'alert-success' : 'alert-danger'">
        {{ message }}
      </div>

      <form @submit.prevent="submitFirstAccess">
        <div class="mb-3">
          <label class="form-label" for="usuario">Usuario</label>
          <input id="usuario" v-model.trim="form.usuario" type="text" class="form-control" required />
        </div>

        <div class="mb-3">
          <label class="form-label" for="passwordTemporal">Credencial temporal</label>
          <div class="password-field">
            <input
              id="passwordTemporal"
              v-model="form.password_temporal"
              :type="verTemporal ? 'text' : 'password'"
              class="form-control"
              required
            />
            <button
              type="button"
              class="password-visibility-btn"
              :aria-label="verTemporal ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              @click="verTemporal = !verTemporal"
            >
              <i :class="verTemporal ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label" for="newPassword">Nueva contraseña</label>
          <div class="password-field">
            <input
              id="newPassword"
              v-model="form.new_password"
              :type="verNueva ? 'text' : 'password'"
              class="form-control"
              required
            />
            <button
              type="button"
              class="password-visibility-btn"
              :aria-label="verNueva ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              @click="verNueva = !verNueva"
            >
              <i :class="verNueva ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <small class="text-muted">
            Mínimo 12 caracteres, con mayúscula, minúscula, número y carácter especial.
          </small>
        </div>

        <div class="mb-3">
          <label class="form-label" for="newPasswordConfirm">Confirmar nueva contraseña</label>
          <div class="password-field">
            <input
              id="newPasswordConfirm"
              v-model="form.new_password_confirm"
              :type="verConfirma ? 'text' : 'password'"
              class="form-control"
              required
            />
            <button
              type="button"
              class="password-visibility-btn"
              :aria-label="verConfirma ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              @click="verConfirma = !verConfirma"
            >
              <i :class="verConfirma ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
        </div>

        <div class="form-check agreement-box">
          <input
            id="agreement"
            v-model="form.acuerdo_responsabilidad_confirmado"
            class="form-check-input"
            type="checkbox"
          />
          <label class="form-check-label" for="agreement">
            Confirmo que firmé y comprendo el acuerdo de responsabilidad fuera del sistema.
          </label>
        </div>

        <button type="submit" class="btn btn-dark w-100 mt-4" :disabled="submitting">
          {{ submitting ? 'Procesando...' : 'Activar cuenta' }}
        </button>

        <button type="button" class="btn btn-link w-100 mt-2" @click="$router.push('/')">
          Volver al inicio de sesión
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import apiService from '@/services/apiService';

export default {
  name: 'FirstAccessView',
  data() {
    return {
      verTemporal: false,
      verNueva: false,
      verConfirma: false,
      submitting: false,
      isSuccess: false,
      message: '',
      form: {
        usuario: this.$route.query.usuario || '',
        password_temporal: '',
        new_password: '',
        new_password_confirm: '',
        acuerdo_responsabilidad_confirmado: false
      }
    };
  },
  methods: {
    async submitFirstAccess() {
      this.message = '';
      this.isSuccess = false;

      if (this.form.new_password !== this.form.new_password_confirm) {
        this.message = 'La confirmación de contraseña no coincide.';
        return;
      }

      if (!this.form.acuerdo_responsabilidad_confirmado) {
        this.message = 'Debe confirmar el recordatorio del acuerdo de responsabilidad.';
        return;
      }

      this.submitting = true;
      try {
        await apiService.post('/api/auth/first-access/complete', {
          usuario: this.form.usuario,
          password_temporal: this.form.password_temporal,
          new_password: this.form.new_password,
          acuerdo_responsabilidad_confirmado: this.form.acuerdo_responsabilidad_confirmado
        });

        this.isSuccess = true;
        this.message = 'Cuenta activada correctamente. Ya puede iniciar sesión.';
        this.form.password_temporal = '';
        this.form.new_password = '';
        this.form.new_password_confirm = '';
        this.form.acuerdo_responsabilidad_confirmado = false;
        window.setTimeout(() => {
          this.$router.push({
            path: '/',
            query: { usuario: this.form.usuario }
          });
        }, 1200);
      } catch (error) {
        this.message = error.response?.data?.message || error.userMessage || 'No se pudo completar la activación inicial.';
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.first-access-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #f5f1e8 0%, #ffffff 55%, #ece7dc 100%);
}

.first-access-card {
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
}

.title {
  margin-bottom: 8px;
  color: #1f2933;
}

.subtitle {
  margin-bottom: 24px;
  color: #52606d;
}

.agreement-box {
  background: #f8f6f1;
  border: 1px solid #e3ddd0;
  border-radius: 10px;
  padding: 12px;
}

.alert {
  padding: 12px 14px;
  border-radius: 10px;
  margin-bottom: 16px;
}

.alert-success {
  background: #edfdf3;
  color: #0f5132;
}

.alert-danger {
  background: #fff1f0;
  color: #842029;
}

.password-field {
  position: relative;
}

.password-field .form-control {
  padding-right: 2.5rem;
}

.password-visibility-btn {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  background: none;
  border: none;
  padding: 0 0.25rem;
  color: #6c757d;
  cursor: pointer;
  line-height: 1;
}

.password-visibility-btn:hover {
  color: #343a40;
}
</style>
